export interface IDealerPermissions {
	canExportData: Boolean;
	canAdjustment: Boolean;
	canAssignAccountMirroringPolicy: Boolean;
	canAssignAgentCommissionPolicy: Boolean;
	canAssignRoboPolicy: Boolean;
	canChangeCashDeliveryStatus: Boolean;
	canChangeCreditLoanStatus: Boolean;
	canChangeDepositRequestStatus: Boolean;
	canChangeTransactionDate: Boolean;
	canControlBanks: Boolean;
	canControlBranches: Boolean;
	canControlPercentage1: Boolean;
	canControlPercentage2: Boolean;
	canControlPercentage3: Boolean;
	canControlPercentage4: Boolean;
	canControlServerSettings: Boolean;
	canControlSmsProvider: Boolean;
	canControlSoukItems: Boolean;
	canCreateAccountMirroringPolicy: Boolean;
	canCreateAgentCommissionPolicy: Boolean;
	canCreateClient: Boolean;
	canCreateClientCurrencyPolicy: Boolean;
	canCreateClientGenericPolicy: Boolean;
	canCreateDealer: Boolean;
	canCreateDealerCurrencyPolicy: Boolean;
	canCreateDealerGenericPolicy: Boolean;
	canCreateManualPositionOutsideHighLow: Boolean;
	canCreateOffice: Boolean;
	canCreateRoboDealerPolicy: Boolean;
	canCreateUpdateDemo: Boolean;
	canCreateUpdateMultisession: Boolean;
	canCreditIn: Boolean;
	canCreditOut: Boolean;
	canDeleteClient: Boolean;
	canManageLeads: Boolean;
	canManageClickToCallMapping: Boolean;
	canSeeLeadsMobile: Boolean;
	canDeposit: Boolean;
	canDisconnectClient: Boolean;
	canDisconnectDealer: Boolean;
	canDoSettlement: Boolean;
	canManageCurrencySetting: Boolean;
	canManagePosition: Boolean;
	canOpenCloseMannualPosition: Boolean;
	canOpenCloseMarketPosition: Boolean;
	canOpenEntryOrder: Boolean;
	canRestartServices: Boolean;
	canViewClientDetails: Boolean;
	canSeeClientNames: Boolean;
	canSeeMobileNumbers: Boolean;
	canSeeFloatingScreen: Boolean;
	canSeeManualHandlingScreen: Boolean;
	canSeeMarginCallScreen: Boolean;
	canSeeOnlineSessionScreen: Boolean;
	canSeeReportCashRequest: Boolean;
	canSeeReportCloseHistory: Boolean;
	canSeeReportCloseRoboOrders: Boolean;
	canSeeReportCreditLoans: Boolean;
	canSeeReportDepositRequest: Boolean;
	canSeeReportFinancialStandings: Boolean;
	canSeeReportJournal: Boolean;
	canSeeReportLoginHistory: Boolean;
	canSeeReportMoneyTransactions: Boolean;
	canSeeReportOpenHistory: Boolean;
	canSeeReportOpenPositions: Boolean;
	canSeeReportOpenRoboOrders: Boolean;
	canSeeReportOrders: Boolean;
	canSeeReportTransactionsLog: Boolean;
	canSeeReportUserDetails: Boolean;
	canSeeSettledScreen: Boolean;
	canSeeTransactionLogScreen: Boolean;
	canSendAnnouncement: Boolean;
	canSendClientSms: Boolean;
	canSendEmail: Boolean;
	canShowHideHistoryTransactions: Boolean;
	canTransferClients: Boolean;
	canUpdateAllFields: Boolean;
	canUpdateAutoMarket: Boolean;
	canUpdateAutoOrder: Boolean;
	canUpdateBuyHoldingMarginType: Boolean;
	canUpdateBuyHoldingMarginValue: Boolean;
	canUpdateBuyOnly: Boolean;
	canUpdateCanTransferMoney: Boolean;
	canUpdateClient: Boolean;
	canUpdateClientPriceExecution: Boolean;
	canUpdateCloseCommissionType: Boolean;
	canUpdateDeleteAccountMirroringPolicy: Boolean;
	canUpdateDeleteAgentCommissionPolicy: Boolean;
	canUpdateDeleteClientCurrencyPolicy: Boolean;
	canUpdateDeleteClientGenericPolicy: Boolean;
	canUpdateDeleteDealer: Boolean;
	canUpdateDeleteDealerCurrencyPolicy: Boolean;
	canUpdateDeleteDealerGenericPolicy: Boolean;
	canUpdateDeleteEntryOrder: Boolean;
	canUpdateDeleteMoneyTransaction: Boolean;
	canUpdateDeletePosition: Boolean;
	canUpdateDeleteRoboDealerPolicy: Boolean;
	canUpdateIntraDayCommissionValue: Boolean;
	canUpdateIntradayCommissionType: Boolean;
	canUpdateLimitOffset: Boolean;
	canUpdateLimitOffsetType: Boolean;
	canUpdateMaxDeals: Boolean;
	canUpdateMaxQuantity: Boolean;
	canUpdateMaxValue: Boolean;
	canUpdateMinDeals: Boolean;
	canUpdatePercentageOffset: Boolean;
	canUpdateRequiredMarginType: Boolean;
	canUpdateRequiredMarginValue: Boolean;
	canUpdateSellHoldingMarginType: Boolean;
	canUpdateSellHoldingMarginValue: Boolean;
	canUpdateSellOnly: Boolean;
	canUpdateSellRequiredMarginType: Boolean;
	canUpdateSellRequiredMarginValue: Boolean;
	canUpdateSpreadBalance: Boolean;
	canUpdateSpreadType: Boolean;
	canUpdateSpreadValue: Boolean;
	canUpdateStopOffset: Boolean;
	canUpdateStopOffsetType: Boolean;
	canUpdateVisible: Boolean;
	canWithdraw: Boolean;
	canWithdrawCreditOutMoreThanAvailableBalance: Boolean;
	closeCommissionValue: Boolean;
	' gmtOffset': Boolean;
	openCommissionType: Boolean;
	openedCommissionValue: Boolean;
	slideNews: Boolean;
}

export const hydrateDealerPermissions = (data: unknown): Partial<IDealerPermissions> => {
	if (!data || typeof data !== 'object' || Array.isArray(data)) {
		return {};
	}

	const permissions = data as Partial<IDealerPermissions>;
	const hydratedPermissions = { ...permissions };

	if (Object.prototype.hasOwnProperty.call(permissions, 'canSeeMobileNumbers')) {
		hydratedPermissions.canSeeMobileNumbers = permissions.canSeeMobileNumbers === true;
	}

	return hydratedPermissions;
};
